import { render, staticRenderFns } from "./InformationButton.vue?vue&type=template&id=2a05558f&scoped=true&"
import script from "./InformationButton.vue?vue&type=script&lang=js&"
export * from "./InformationButton.vue?vue&type=script&lang=js&"
import style0 from "./InformationButton.vue?vue&type=style&index=0&id=2a05558f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05558f",
  null
  
)

export default component.exports